import emitter from "ccxd-ux/src/mixins/emitter";

export default {
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mixins: [emitter],
  watch: {
    disabled(val) {
      if (val === true) {
        this.dispatch("ElFormItem", "el.form.change", this.value);
      }
    },
  },
};
